import { z } from "zod";
export const userAreaNameDtoSchema = z.enum([
    "Agreements",
    "ENG_ConnectionPerformance",
    "ENG_LinerAdvice",
    "ENG_MilkFlowProfile",
    "FMS_Beta",
    "FMS_Core",
    "FMS_Dev",
    "FMS_CareCheck",
    "FMS_VectorLoading",
    "FMS_VectorFreeTime",
    "FMS_FieldAssist",
    "FMS_FieldAssist_Overview",
    "FMS_TeatDetectionSystemLinerAdvice",
    "Juno_Discovery_CriticalAlarmAnalysis",
    "LIOBS_Core",
    "Refactor_JSBEDataSources",
    "Refactor_DataSourcesNewApproach",
    "ServiceManager_Core",
    "ENG_LinerAdvice_PhaseTwo",
    "TSS_Core",
    "TSS_MandatoryUpdates",
    "TSS_Parts",
    "TSS_PreventiveMaintenanceOverdue",
    "TSS_RepairsPerAstronaut",
    "TSS_RepeatVisitCases",
    "TSS_Technician_Core",
    "TSS_TechnicianDetail",
    "TSS_TeamLead_Core",
    "TSS_TeamLeadKPI",
    "TSS_AstronautMax",
    "Horizon_Insights",
    "ConnectionPerformanceDeviceIndex",
    "PredictiveMaintenanceInsights",
    "VectorySystemFreeTimeKPI",
    "MilkingVisitBehaviorIndex",
    "NewPermissionSystem",
]);
export const userAreaDtoSchema = z.object({
    id: z.string().uuid(),
    name: z.string(),
    displayName: z.string(),
});
export const userPermissionsDtoSchema = z.object({
    canAdministrationRead: z.boolean().optional(),
    canAdministrationWrite: z.boolean().optional(),
    canImpersonate: z.boolean().optional(),
    isApplicationManager: z.boolean().optional(),
    canAdministerInsights: z.boolean().optional(),
    canFilterClusters: z.boolean().optional(),
});
export const userClusterDtoSchema = z.object({
    id: z.string().uuid(),
    name: z.string(),
});
export const userRoleTypeDtoSchema = z.enum(["primary", "secondary"]);
const userRoleLeafSchema = z.object({
    id: z.string().uuid(),
    type: userRoleTypeDtoSchema,
    name: z.string(),
    areas: z.array(userAreaDtoSchema),
    mainRoleId: z.string().uuid().nullable(),
});
export const userRoleDtoSchema = userRoleLeafSchema.extend({
    children: z.array(userRoleLeafSchema),
});
export const userSettingLanguageDtoSchema = z.object({ name: z.literal("language"), value: z.string() });
export const userSettingUnitsDtoSchema = z.object({ name: z.literal("units"), value: z.enum(["Metric", "Imperial"]) });
export const userSettingPrimaryActiveRoleIdDtoSchema = z.object({
    name: z.literal("primaryActiveRoleId"),
    value: z.string(),
});
export const userSettingSecondaryActiveRolesIdsDtoSchema = z.object({
    name: z.literal("secondaryActiveRolesIds"),
    value: z.string(),
});
export const userSettingActiveViewDtoSchema = z.object({
    name: z.literal("activeView"),
    value: z.string(),
});
export const userSettingDtoSchema = z.union([
    userSettingLanguageDtoSchema,
    userSettingUnitsDtoSchema,
    userSettingPrimaryActiveRoleIdDtoSchema,
    userSettingSecondaryActiveRolesIdsDtoSchema,
    userSettingActiveViewDtoSchema,
    // Catch-all for any other undefined setting
    // z.object({ name: z.string(), value: z.any() }),
]);
export const userAssignedRolesDtoSchema = z.enum(["fmsAdvisor", "tssTechnician", "tssTeamLead", "serviceManager"]);
// New simplified user schema for new permission system
// Thought: is it worth just using the `userDtoSchema`?`
export const userWithAssignedRolesDtoSchema = z.object({
    id: z.string().uuid(),
    name: z.string(),
    assignedRoles: z.array(userAssignedRolesDtoSchema),
});
export const userDtoSchema = z
    .object({
    id: z.string().uuid(),
    name: z.string(),
    cluster: z.string().optional(),
    company: z.string().optional(),
    selectedClusters: z.array(userClusterDtoSchema),
    permissions: userPermissionsDtoSchema,
    roles: z.array(userRoleDtoSchema),
    userSettings: z.array(userSettingDtoSchema),
    // New permission system. Named `assignedRoles` to avoid collision with legacy `roles` — may be renamed once legacy field is removed.
    assignedRoles: z.array(userAssignedRolesDtoSchema),
    activeView: z.string().nullable(),
})
    // TODO: Remove once old backend is deprecated to ensure schemas are identical between frontend and backend
    .passthrough();
//# sourceMappingURL=user.schema.js.map